import { render, staticRenderFns } from "./OrderMessagesTable.vue?vue&type=template&id=4fb91467&scoped=true&"
import script from "./OrderMessagesTable.vue?vue&type=script&lang=js&"
export * from "./OrderMessagesTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderMessagesTable.vue?vue&type=style&index=0&id=4fb91467&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb91467",
  null
  
)

export default component.exports